import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  NavLink,
  useNavigate,
  Navigate,
  Outlet,
} from "react-router-dom";
import ConfirmationModal from "../Components/ConfirmationModal/ConfirmationModal.module";

export const ConfirmationModalContext = React.createContext(null);
const useConfirmationModal = () => {
  return React.useContext(ConfirmationModalContext);
};

export const ConfirmationModalProvider = ({ children }) => {
  const [confirmationTitle, setConfirmationTitle] = useState(null);
  const [handleConfirm, setHandleConfirm] = useState(null);
  const [dataConfirm, setDataConfirm] = useState(null);
  const [handleText, setHandleText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openUpModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const value = {
    confirmTitle: setConfirmationTitle,
    toDo: setHandleConfirm,
    payloadConfirm: setDataConfirm,
    description: setHandleText,
    openUpModal,
    closeModal,
  };

  return (
    <ConfirmationModalContext.Provider value={value}>
      {children}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => closeModal()}
        onConfirm={handleConfirm}
        dataConfirm={dataConfirm}
        text={handleText}
        ConfirmationTitle={confirmationTitle}
      />
    </ConfirmationModalContext.Provider>
  );
};
